export const ADD_MFA_WITH_TOTP_FLOW_ID = 'add-mfa-with-totp';

export enum AddMfaWithTotpScreenNames {
  VERIFY_TOTP = 'Verify TOTP',
}

export const ADD_MFA_WITH_TOTP_SCREEN_IDS = {
  VERIFY_TOTP: 'SC33AKDujkMxmgdEKfy3F6uo1C5mP',
};

export const ADD_MFA_WITH_TOTP_INTERACTION_IDS = {
  SUBMIT_CODE: 'oneTimeCodeId',
};
